/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  FunctionComponent,
  memo,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react"
import { FieldErrors } from "react-hook-form"
import Select from "react-select"
import FormWrap from "../FormWrap"
import { selectStyle } from "./style"

export interface iSelectProps {
  name: string
  initialValue?: any
  options: Array<any>
  isClearable?: boolean
  isSearchable?: boolean
  isMulti?: boolean
  placeholder?: string
  label?: string
  error?: FieldErrors
  onChange?: (prop: any) => void
  value?: any
}

const SelectInput: FunctionComponent<iSelectProps> = ({
  value,
  initialValue,
  options,
  isClearable,
  isSearchable,
  isMulti,
  placeholder,
  name,
  onChange,
  label,
  error,
}) => {
  const [_value, setValue] = useState<any>()

  const style = useMemo(() => {
    return selectStyle({ isMulti: !!isMulti, error })
  }, [isMulti, error])

  const onInputChange = useCallback(
    (data: any) => {
      console.log(data)

      if (Array.isArray(data)) {
        onChange && onChange(data ? data.map((d) => d.value) : [])
      } else {
        onChange && onChange(data ? data.value : isMulti ? [] : "")
      }
    },
    [name],
  )

  useEffect(() => {
    if (Array.isArray(value)) {
      const values: any[] = []
      value.forEach((v) => {
        const x = options.find((x) => x.value === v)
        if (x) values.push(x)
      })
      setValue(values)
    } else {
      setValue(
        typeof value === "string"
          ? options.find((x) => x.value === value) || ""
          : value,
      )
    }
  }, [initialValue, options, value])

  return (
    <div className="form-group">
      {(label || error) && (
        <label htmlFor={name}>
          {label}
          {error && <span>{error.message}</span>}
        </label>
      )}
      <div className="form-control">
        <Select
          isClearable={isClearable}
          isMulti={isMulti}
          value={_value}
          id={name}
          isSearchable={isSearchable}
          classNamePrefix={"react-select"}
          className={"select"}
          placeholder={placeholder}
          options={options}
          styles={style}
          menuPlacement="auto"
          onChange={onInputChange}
        />
      </div>
    </div>
  )
}

const MemoSelectInput = memo(SelectInput, (currentProps, nextProps) => {
  const { initialValue } = currentProps
  const { initialValue: nextInitial } = nextProps

  return (
    initialValue === nextInitial &&
    currentProps.error?.message === nextProps.error?.message &&
    currentProps.options === nextProps.options
  )
})
// export default MemoSelectInput

export default SelectInput

export const FormSelectInput = FormWrap<iSelectProps>(MemoSelectInput)
